import { Component, Input, ElementRef, AfterViewInit, ChangeDetectionStrategy } from '@angular/core';
import { TranslateDirective } from 'i18n';

@Component({
  selector: 'spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss'],
  imports: [TranslateDirective],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SpinnerComponent implements AfterViewInit {
  @Input() text: string = 'loading';
  
  constructor(private elementRef: ElementRef) {}

  ngAfterViewInit() {
    // const fontSize = window.getComputedStyle(this.elementRef.nativeElement).fontSize;
    // const fontSizeValue = parseFloat(fontSize);
    // this.elementRef.nativeElement.style.setProperty('--spinner-size', `${fontSizeValue * 4}px`);
    // this.elementRef.nativeElement.style.setProperty('--border-width', `${fontSizeValue / 4}px`);
  }
}